import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { colors } from "../data/tokens";

// Cor semântica do status de cargo (os nomes vêm da tabela de Status de
// Cargos e Funções, definidos pelo próprio Clube — casa por conteúdo).
// Usado na ficha do sócio (aba Cargos e Funções) e na tela de Status.
export const roleStatusChipColor = (
  name?: string
): "success" | "warning" | "default" => {
  const n = String(name || "").toUpperCase();
  if (n.includes("ATUA")) return "success"; // EM ATUAÇÃO
  if (n.includes("AFASTAD") || n.includes("LICENCIAD")) return "warning";
  return "default"; // MANDATO ENCERRADO e demais
};

export const RoleStatusChip = ({ name }: { name?: string }) => {
  if (!name) return null;
  return (
    <Chip
      size="small"
      variant="outlined"
      color={roleStatusChipColor(name)}
      label={name}
    />
  );
};

// Variante "legenda": bolinha colorida + nome — mesmo desenho do
// CategoryDot das Categorias de Sócios, para a lista de Status
export const RoleStatusDot = ({ name }: { name?: string }) => {
  if (!name) return null;
  const color = roleStatusChipColor(name);
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={(theme: any) => ({
          width: 10,
          height: 10,
          borderRadius: "50%",
          flexShrink: 0,
          backgroundColor:
            color === "default"
              ? colors.neutral300
              : theme.palette[color].main,
        })}
      />
      <Typography
        sx={{ fontSize: 13.5, fontWeight: 600, color: colors.primaryDark }}
      >
        {name}
      </Typography>
    </Box>
  );
};
